import Container from "typedi";
import VueFramework from "./vue/Vue.framework";

export default class Frameworks {
    public static getVue(): VueFramework {
        return Container.get(VueFramework);
    }
}
